import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import swal from "sweetalert";
import NewTeammateDetail from "./Components/NewTeammateDetail";
import { createChildUser, getUserById, updateChildUser, getActivePlan, getMeber, deleteUserData, resetPassword } from "../WorkSpace/Components/ApiServices/apiHandler";
import AddminNav from "./AddminNav";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { generatePassword } from "../helper/accessibility";
import { Button } from "../myfin_v2/elements/Button";
import Sidebar from "../myfin_v2/elements/Sidebar";
import Modal from "../myfin_v2/elements/Modal";
import InputGroup from "../myfin_v2/elements/InputGroup";
import adminPortalCss from "../myfin_v2/css/adminportal.module.css";
import modalcss from "../myfin_v2/css/modal.module.css";
import buttoncss from "../myfin_v2/css/button.module.css";
import MemberCreationProgressBar from "../myfin_v2/components/adminportal/MemberCreationProgressBar";
import SuccessModal from "../myfin_v2/components/connections/SuccessModal";
import ErrorModal from "../myfin_v2/components/connections/ErrorModal";
import { ReactComponent as RightIcon } from "../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as DeleteIcon } from "../myfin_v2/assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../myfin_v2/assets/icons/close.svg";

const AddTeamate = () => {
    const history = useHistory();
    const { childUserId } = useParams();
    const [childUserCount, setChildUserCount] = useState(0);
    const [users, setUsers] = useState(0)
    const [newUserData, setNewUserData] = useState({
        email: "",
        name: "",
        responsibilities: "preparer",
        role: "",
        unrestrictedaccess: false,
    });

    const [tempPassword, setTempPassword] = useState("")

    const [displayModal, setDisplayModal] = useState(false);
    const [deleteMemberModal, setDeleteMemberModal] = useState(false);
    const [resetPasswordModal, setResetPasswordModal] = useState(false);
    const [showSuccessToaster, setShowSuccessToaster] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [showErrorToaster, setShowErrorToaster] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (childUserId) {
            GetUserById(childUserId);
        }
        activePlanData();
        countAllMember();
    }, [])

    const GetUserById = (userId) => {
        getUserById(userId).then(response => {
            const userData = response.data?.user
            setNewUserData(prev => ({
                ...prev,
                email: userData.email,
                name: userData.name,
                responsibilities: userData.responsibilities,
                role: userData.role,
                unrestrictedaccess: userData.unrestrictedaccess,
            }));
            setTempPassword(userData.temp_password)
        }).catch(error => {
            swal(
                "Error",
                error.response?.data?.error || "Member Data Fetched Failed!",
                "error"
            );
        })
    }

    const HandleNewUserSubmit = async () => {
        const generatedPassword = generatePassword();

        createChildUser({
            email: newUserData.email,
            name: newUserData.name,
            responsibilities: newUserData.responsibilities,
            role: newUserData.role,
            unrestrictedaccess: newUserData.unrestrictedaccess,
            temp_password: generatedPassword
        }).then((response) => {
            toast.success("Team Member Added Successfully.");
            const childUserId = response.data.data._id;
            if (newUserData.unrestrictedaccess) {
                history.push(`/admin`);
            } else {
                history.push(`/select-company/${childUserId}`);
            }
        }).catch(error => {
            swal(
                "Error",
                error.response?.data?.error || "Team Member Added Failed!",
                "error"
            );
        })
    }

    const UpdateMember = () => {
        updateChildUser(childUserId, {
            name: newUserData?.name,
            email: newUserData?.email,
            role: newUserData?.role,
            responsibilities: newUserData?.responsibilities,
            unrestrictedaccess: newUserData?.unrestrictedaccess
        }).then(response => {
            toast.success("Member Updated Successfully.");
            history.push(`/select-company/${childUserId}/update`);
        }).catch(error => {
            swal(
                "Error",
                error.response?.data?.error || "Member Data Fetched Failed!",
                "error"
            );
        })
    }

    const countAllMember = async () => {
        getMeber().then(response => {
            setChildUserCount(response.data?.fetchMember?.length);
        }).catch(error => {
            swal(
                "Error",
                error.response?.data?.error || "Get All Member Data Failed!",
                "error"
            );
        });
    }

    const activePlanData = async () => {
        getActivePlan().then(response => {
            setUsers(response.data?.categorizedBenefits?.noOfUsers[0]);
        }).catch(error => {
            swal(
                "Error",
                error.response?.data?.error || "Get Active Data Failed!",
                "error"
            );
        });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'unrestrictedaccess') {
            setNewUserData(prev => ({ ...prev, [name]: !prev.unrestrictedaccess }));
        } else {
            setNewUserData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleClose = () => {
        setDisplayModal(false);
    };

    const handleDeleteMember = async (userId) => {
        try {
            await deleteUserData(userId);
            handleClose();
            setDeleteMemberModal(false);
            history.push(`/admin`)

            toast.success("Team Member Deleted Successfully.");
        } catch (error) {
            toast.error(error.response?.data?.error || "Team member delete failed!");
        }
    }
    
    const handleResetPassword = async (userId) => {

        const tempPassword = generatePassword();

        await resetPassword({
            tempPassword,
            userId
        })

        handleClose();
        setResetPasswordModal(false);
        showToaster("Email Sent Sucessfully!", "success")

    }

    //Toaster

	const showToaster = (message, type) => {
        if (type === "success") {
            setSuccessMessage(message);
            setShowSuccessToaster(true);
            setTimeout(() => {
                setShowSuccessToaster(false);
                setSuccessMessage("");
            }, 3000); // Hide after 3 seconds
        } else if (type === "error") {
            setErrorMessage(message);
            setShowErrorToaster(true);
            setTimeout(() => {
                setShowErrorToaster(false);
                setErrorMessage("");
            }, 3000); // Hide after 3 seconds
        }
    };

	const handleCloseSuccessToaster = () => {
        setShowSuccessToaster(false);
        setSuccessMessage("");
    };

    const handleCloseErrorToaster = () => {
        setShowErrorToaster(false);
        setErrorMessage("");
    };

    return (
        <>
            <div className={adminPortalCss.dFlex}>
                <Sidebar />
                <div className={adminPortalCss.memberScreenLayout}>
                    <div className={adminPortalCss.mSProgress}>
                        <motion.div
                            initial={{ x: -100, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: -100, opacity: 0 }}
                            transition={{ duration: 1, ease: "easeInOut" }}
                            className="w-100"
                        >

                            <MemberCreationProgressBar ActiveStage={1}/>
                        </motion.div>
                    </div>
                    {/* <div className={adminPortalCss.dataCard}>
                            <span className={`${adminPortalCss.msHeadingText} ${adminPortalCss.msGdHeading}`}>Let’s start with your details</span>
                        <div className={adminPortalCss.msGeneraldetailLayout}>
                            <div className={adminPortalCss.msGeneraldetailInput}>
                                <InputGroup
                                    label="Email Id"
                                    req={true}
                                    inputs={[
                                        <>
                                            <input
                                                type="text"
                                                name="email"
                                                value={newUserData.email}
                                                onChange={handleInputChange}
                                            />
                                        </>,
                                    ]}
                                />
                                <InputGroup
                                    label="Username"
                                    req={true}
                                    inputs={[
                                        <>
                                            <input
                                                type="text"
                                                name="name"
                                                value={newUserData.name}
                                                onChange={handleInputChange}
                                            />
                                        </>,
                                    ]}
                                />
                                <InputGroup
                                    label="Role"
                                    req={true}
                                    inputs={[
                                        <>
                                            <input
                                                type="text"
                                                name="role"
                                                value={newUserData.role}
                                                onChange={handleInputChange}
                                            />
                                        </>,
                                    ]}
                                />
                                <div className={adminPortalCss.dFlexClm}>
                                    <label className={`${adminPortalCss.customLabel} mt-2`}>
                                        Choose responsibilities
                                    </label>
                                    <div className={adminPortalCss.radioButtonSection}>
                                        <span>
                                            <ActiveRadioBtn /> Preparer
                                        </span>
                                        <span>
                                            <ActiveRadioBtn /> Approver
                                        </span>
                                        <span>
                                            <ActiveRadioBtn /> Unrestricted Access
                                        </span>
                                        <span>
                                            <ActiveRadioBtn /> View Only
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        className="w-100"
                    >

                        <NewTeammateDetail
                            newUserData={newUserData}
                            setNewUserData={setNewUserData}
                            tempPassword = {tempPassword}
                        />
                    </motion.div>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: -100, opacity: 0 }}
                        transition={{ duration: 1, ease: "easeInOut" }}
                        className="w-100"
                    >
                        <div className={adminPortalCss.footerSection}>
                            <div className={adminPortalCss.footerData}>
                                <button
                                    className={adminPortalCss.outlinedBtn}
                                    onClick={() => history.push(`/admin`)}
                                >
                                    Cancel
                                </button>
                                <div className={adminPortalCss.footerRightBtn}>

                                    {childUserId && (
                                        <div className={adminPortalCss.dFlex}
                                            style={{gap:"20px"}}
                                        >
                                            <span
                                                style={{
                                                    color:"#E30000",
                                                    fontWeight:"500",
                                                    cursor:"pointer"
                                                }}

                                                onClick={() => {
                                                    setDisplayModal(true);
                                                    setDeleteMemberModal(true);
                                                }}
                                                
                                            >Delete Member</span>

                                            <span
                                                style={{
                                                    color:"#2D8861",
                                                    fontWeight:"500",
                                                    cursor:"pointer"
                                                }}
                                                onClick={() => {
                                                    setDisplayModal(true);
                                                    setResetPasswordModal(true);
                                                }}
                                            >
                                                Reset Password
                                            </span>
                                        </div>
                                    )}

                                    {childUserCount >= users ? (<button
                                        className={adminPortalCss.primaryBtn}
                                        onClick={() => {
                                            if(childUserId){
                                                UpdateMember()
                                            }else{
                                                HandleNewUserSubmit()
                                            }
                                        }}
                                        disabled
                                    >
                                        { newUserData.unrestrictedaccess ? "Create" : "Next"} <RightIcon />
                                    </button>)
                                    :
                                    (<button
                                        className={adminPortalCss.primaryBtn}
                                        onClick={() => {
                                            if(childUserId){
                                                UpdateMember()
                                            }else{
                                                HandleNewUserSubmit()
                                            }
                                        }}
                                    >
                                        { newUserData.unrestrictedaccess ? "Create" : "Next"} <RightIcon />
                                    </button>)}
                                    
                                </div>
                            </div>
                        </div>
                    </motion.div>
                    {deleteMemberModal && displayModal && (
                        <Modal
                        headerActions={
                            <CloseIcon
                            onClick={() => {
                                handleClose();
                                setDeleteMemberModal(false);
                            }}
                            className="clickable"
                            />
                        }
                        headerBottomLine={false}
                        onClose={() => console.log("Modal Closed")}
                        >
                        <span className={`${modalcss.modalBodyHead} mb-1`}>
                            Do you want to <span className="fw700">delete</span> the
                            member?
                        </span>
                        <span
                            className={`${modalcss.modalBodycnt}`}
                            style={{ "margin-bottom": "35px" }}
                        >
                            You can restore the deleted members
                        </span>
                        <span
                            className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
                        >
                            <Button
                            btnColor={buttoncss.danger}
                            label="Yes, Delete"
                            onClick={() => {
                                handleDeleteMember(childUserId);
                            }}
                            />
                            <Button
                            btnColor={buttoncss.secondary_del}
                            label="No, Cancel"
                            onClick={() => {
                                handleClose();
                                setDeleteMemberModal(false);
                            }}
                            />
                        </span>
                        </Modal>
                    )}
                    {resetPasswordModal && displayModal && (
                        <Modal
                            headerActions={
                            <CloseIcon
                                onClick={() => {
                                    handleClose();
                                    setDeleteMemberModal(false);
                                }}
                            className="clickable"
                            />
                        }
                        headerBottomLine={false}
                        onClose={() => console.log("Modal Closed")}
                        >
                        <span className={`${modalcss.modalBodyHead} mb-1`}>
                            Reset Password?
                        </span>
                        <span
                            className={`${modalcss.modalBodycnt}`}
                            style={{ "margin-bottom": "35px" }}
                        >
                            A temporary password will be sent to your email to reset your password. Your old password won’t be valid anymore
                        </span>
                        <span
                            className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
                        >
                            <Button
                            btnColor={buttoncss.secondary_del}
                            label="Cancel"
                            onClick={() => {
                                handleClose();
                                setResetPasswordModal(false);
                            }}
                            />
                            <Button
                                btnColor={buttoncss.primary}
                                label="Proceed"
                                onClick={() => {
                                    handleResetPassword(childUserId);
                                }}
                            />
                        </span>
                        </Modal>
                    )}

                    {showSuccessToaster && (
                        <SuccessModal
                            handleClose={handleCloseSuccessToaster}
                            setSuccessModal={setShowSuccessToaster} 
                            setSuccessMessage={setSuccessMessage} 
                            successMessage={successMessage}
                            bodycls=""
                        />
                    )}
        
                    {showErrorToaster && (
                        <ErrorModal
                            handleClose={handleCloseErrorToaster}
                            setErrorModal={setShowErrorToaster} 
                            setErrorMessage={setErrorMessage}
                            errorMessage={errorMessage}
                        />
                    )}
                </div>
            </div>
            {/* <div>
        <AddminNav />
        <div className="px-4 py-3">
          <Card className="w-100 radius-12px px-3 py-3">
            <div>
              <p className="mt-0 mb-0 font-size-18 custom-font-600 font-sans ">
                Add Teamate
              </p>
              <p className="mt-0 mb-2 font-size-16 custom-font-500 font-sans">
                Fill out all the requirements to create new Teammate
              </p>
            </div>
            <div
              className="mt-3 general-box">
              <div className="d-flex flex-wrap p-2">
                <div
                  className="d-flex justify-content-center align-items-center mt-1 orange-circle">
                  <p className="mt-0 mb-0 font-size-12 custom-font-600 font-sans">
                    1
                  </p>
                </div>
                <div className="flex-grow-1">
                  <p className="mt-2 p-1 mb-0 font-size-12 custom-font-600 font-sans" style={{ color:"Brown" }}>
                    General
                    Details<span className="text-secondary">-------------------------------------------------------</span>
                  </p>
                </div>
                <div
                  className="d-flex justify-content-center align-items-center mt-1 white-circle" style={{ border:"1px solid #8692A6" }}>
                  <p className="mt-0 mb-0 font-size-12 custom-font-600 font-sans">
                    2
                  </p>
                </div>
                <div className="flex-grow-1">
                  <p className="mt-2 p-1 mb-0 font-size-12 custom-font-600 font-sans text-secondary">
                    Select
                    Companies-------------------------------------------------------
                  </p>
                </div>
                <div
                  className="d-flex justify-content-center align-items-center mt-1 white-circle"
                  style={{
                    border:"1px solid #8692A6"
                  }}
                >
                  <p className="mt-0 mb-0 font-size-12 custom-font-600 font-sans">
                    3
                  </p>
                </div>
                <div className="flex-grow-1">
                  <p className="mt-2 p-1 mb-0 font-size-12 custom-font-600 font-sans text-secondary">
                    Responsibilities
                  </p>
                </div>
              </div>
            </div>

            <NewTeammateDetail
              newUserData={newUserData}
              setNewUserData={setNewUserData}
              users={users}
              childUserCount={childUserCount}
              onClick={() => {
                if(childUserId){
                  UpdateMember()
                }else{
                  HandleNewUserSubmit()
                }
              }}
            />
          </Card>
        </div>
      </div> */}
        </>
    );
};

export default AddTeamate;
